/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AdminUser } from '@SERVICES';

export interface DeleteUserModalState {
    isOpen: boolean;
    data: AdminUser | null;
    confirmed: boolean;
}

const initialState: DeleteUserModalState = {
    isOpen: false,
    data: null,
    confirmed: false,
};

export const deleteUserModalSlice = createSlice({
    name: 'delete-user-modal',
    initialState,
    reducers: {
        open(state: DeleteUserModalState, action: PayloadAction<AdminUser>) {
            state.isOpen = true;
            state.data = action.payload;
            state.confirmed = false;
        },
        close(state: DeleteUserModalState) {
            state.isOpen = false;
            state.data = null;
            state.confirmed = false;
        },
        confirm(state: DeleteUserModalState) {
            state.confirmed = true;
        },
    },
}); 